import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Calendar = () => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
  return (
    <div className="p-6 h-full flex flex-col pb-24 md:pb-6">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Schedule</h1>
      </header>
      
      <div className="flex-1 glass-panel rounded-2xl p-4 flex flex-col">
        <div className="grid grid-cols-7 gap-1 text-center mb-4">
          {days.map(d => <div key={d} className="text-xs text-slate-500 font-medium py-2">{d}</div>)}
        </div>
        <div className="grid grid-cols-7 gap-1 flex-1">
          {Array.from({length: 35}).map((_, i) => (
            <div key={i} className={`border border-slate-800/50 rounded-md p-1 min-h-[60px] ${i === 12 ? 'bg-slate-800 border-teal-500/30' : 'bg-slate-900/30'}`}>
              <span className={`text-xs ${i === 12 ? 'text-teal-400 font-bold' : 'text-slate-600'}`}>{i + 1 > 31 ? i - 30 : i + 1}</span>
              {i === 12 && <div className="mt-1 w-full h-1 rounded bg-amber-500/50"></div>}
              {i === 15 && <div className="mt-1 w-full h-1 rounded bg-teal-500/50"></div>}
            </div>
          ))}
        </div>
        <div className="mt-4 flex gap-4 text-xs text-slate-400">
          <span className="flex items-center gap-1"><div className="w-2 h-2 rounded bg-amber-500/50" /> Maintenance</span>
          <span className="flex items-center gap-1"><div className="w-2 h-2 rounded bg-teal-500/50" /> Chores</span>
        </div>
      </div>
    </div>
  );
};

export default Calendar;